<template>
  <el-tooltip
    v-if="hasOption"
    v-model:visible="visible"
    virtual-triggering
    :virtual-ref="lazyVTooltipElem"
    v-bind="tooltipOption"
    :popper-class="['v-tooltip-popper', tooltipOption?.popperClass]"
  />
</template>

<script setup lang="ts">
import { findParentElement } from '@joinf/utils'
import { useElementVisibility, useEventListener } from '@vueuse/core'

import { useLazyElem, useTooltipOption } from '@/directive/v-tooltip/hooks'
import { isVTooltipElement } from '@/directive/v-tooltip/utils'

const visible = ref(true)
const lazyVTooltipElem = useLazyElem()
const { tooltipOption, hasOption } = useTooltipOption(lazyVTooltipElem)

const isVisible = useElementVisibility(lazyVTooltipElem)
watch(isVisible, isVisible => {
  if (!isVisible) {
    lazyVTooltipElem.value = null
  }
})

useEventListener(document, 'mouseover', e => {
  const target = e.target as HTMLElement
  const tooltipElem = findParentElement<HTMLElement>(target, isVTooltipElement)
  // 移动到 v-tooltip 元素
  if (tooltipElem) {
    lazyVTooltipElem.value = tooltipElem
    return
  }

  // 移动到 v-tooltip 弹出框
  const tooltipWrapper = findParentElement(target, el => el?.className?.includes?.('el-popper'))
  if (tooltipWrapper && lazyVTooltipElem.value) {
    // 需要重新赋值以停止内部的延迟赋空操作
    lazyVTooltipElem.value = unref(lazyVTooltipElem)
    return
  }

  // 移动到其他元素
  lazyVTooltipElem.value = null
})
</script>

<style lang="scss">
/* stylelint-disable-next-line import-notation, scss/load-partial-extension -- 需保留 scss 后缀, 否则 vite 无法解析该样式 */
@import './v-tooltip-comp.scss';
</style>
